// Plugins
import GLightbox from '../../../../vendor/glightbox/glightbox.min.js';
import Choices from '../../../../vendor/choices.js/public/assets/scripts/choices';

// Local
export default function initUitKit($wrapper) {
    $wrapper.querySelectorAll('[data-animate]').forEach(async($item) => {
        const Animate = await import('./partials/animate');
        (new Animate.default($item));
    });
    $wrapper.querySelectorAll('[data-form]').forEach(async($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
    $wrapper.querySelectorAll('[data-upload]').forEach(async($el) => {
        const UploadControl = await import('./partials/upload-control');
        (new UploadControl.default($el));
    });
    $wrapper.querySelectorAll('[data-alert]').forEach(async($el) => {
        const Alert = await import('./partials/alert');
        (new Alert.default($el));
    });
    $wrapper.querySelectorAll('[data-collapsible]').forEach(async($el) => {
        const Collapsible = await import('./partials/collapsible');
        (new Collapsible.default($el));
    });
    $wrapper.querySelectorAll('[data-modal]').forEach(async($el) => {
        const Modal = await import('./partials/modal');
        (new Modal.default($el));
    });
    $wrapper.querySelectorAll('[data-tabs]').forEach(async($el) => {
        const Tabs = await import('./partials/tabs');
        (new Tabs.default($el));
    });
    $wrapper.querySelectorAll('[data-dropdown]').forEach(async($el) => {
        const Dropdown = await import('./partials/dropdown');
        (new Dropdown.default($el));
    });
    $wrapper.querySelectorAll('[data-password]').forEach(async($el) => {
        const PasswordControl = await import('./partials/password-control');
        (new PasswordControl.default($el));
    });
    $wrapper.querySelectorAll('[data-autocomplete]').forEach(async($el) => {
        const Autocomplete = await import('./partials/autocomplete');
        (new Autocomplete.default($el));
    });
    $wrapper.querySelectorAll('[data-loader]').forEach(async($el) => {
        const Loader = await import('./partials/loader');
        (new Loader.default($el));
    });
    $wrapper.querySelectorAll('[data-mask]').forEach(async ($el) => {
        const IMask = await import('../../../../vendor/imask');
        new IMask.default($el, {mask: $el.dataset.mask});
    });
    $wrapper.querySelectorAll('[data-href]').forEach(async ($el) => {
        const LinkTo = await import('./partials/link-to');
        (new LinkTo.default($el));
    });
    $wrapper.querySelectorAll('[data-copy-to-clipboard]').forEach(async ($el) => {
        const CopyToClipboard = await import('./partials/copy-to-clipboard');
        (new CopyToClipboard.default($el));
    });
    $wrapper.querySelectorAll('[data-message]').forEach(async ($el) => {
        const Message = await import('./partials/message');
        (new Message.default($el));
    });
    $wrapper.querySelectorAll('[data-message]').forEach(async ($el) => {
        const Message = await import('./partials/message');
        (new Message.default($el));
    });
    $wrapper.querySelectorAll('[data-select]').forEach(async($el) => {
        (new Choices($el, {
            placeholder: $el.dataset.selectPlaceholder !== undefined,
            placeholderValue: $el.dataset.selectPlaceholder,
            searchEnabled: $el.querySelectorAll('option').length > 8,
            noResultsText: translations.noResultsText,
            noChoicesText: translations.noChoicesText,
            itemSelectText: '',
            uniqueItemText: translations.uniqueItemText,
            customAddItemText: translations.customAddItemText,
            removeItemButton: false,
            shouldSort: false,
            callbackOnCreateTemplates: function(strToEl) {
                return {
                    choice: (classNames, data) => {
                        const el = Choices.defaults.templates.choice(classNames, data); // Get original element
                        const prefix = data.customProperties?.prefix;

                        if (prefix) {
                            // Create the badge/prefix element
                            const badge = strToEl(`${prefix}`);
                            // Prepend or Append it to the original element
                            el.prepend(badge);
                        }
                        return el;
                    },
                    item: (classNames, data) => {
                        const el = Choices.defaults.templates.item(classNames, data); // Get original element
                        const prefix = data.customProperties?.prefix;

                        if (prefix) {
                            // Create the badge/prefix element
                            const badge = strToEl(`${prefix}`);
                            // Prepend or Append it to the original element
                            el.prepend(badge);
                        }
                        return el;
                    },
                }
            }
        }));
    });

    GLightbox({
        selector: '[data-glightbox]',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });

    // Helper method to check if ui-kit is already initialized
    $wrapper.uiKitInitialized = true;
}